import type { IEventChannel } from "../model/Models";
import type { FeatureViewModel } from "./FeatureViewModel";

export default class ScheduleLocationMapping {
    featureViewModel: FeatureViewModel;
    eventChannel: IEventChannel;

    mapping = {}; // Key: layerViewId_featureId value: array of service(s)

    /**
     * 
     * @param featureViewModel 
     * @param eventChannel 
     */
    constructor(featureViewModel: FeatureViewModel, eventChannel: IEventChannel) {
        this.featureViewModel = featureViewModel;
        this.eventChannel = eventChannel;
    }

    /**
     * 
     * @param services 
     * @param isSuppressEvent 
     */
    add(services: any[], isSuppressEvent?: boolean) {
        for (let service of services) {
            if (service.address) {
                if (!this.mapping.hasOwnProperty(service.address.locationId)) {
                    this.mapping[service.address.locationId] = [service];
                }
                else if (!this.mapping[service.address.locationId].find(s => s.id === service.id)) {
                    this.mapping[service.address.locationId].push(service);
                }
            }
        }

        if (isSuppressEvent !== true) {
            this.eventChannel.fireEvent("onSchedulePointMappingUpdate");
        }
    }

    /**
     * 
     * @param service 
     */
    remove(service) {
        if (this.mapping.hasOwnProperty(service?.address?.locationId)) {
            delete this.mapping[service.address.locationId];
            this.eventChannel.fireEvent("onSchedulePointMappingUpdate");
        }
    }

    /**
     * 
     */
    clear() {
        this.mapping = {};
        this.eventChannel.fireEvent("onSchedulePointMappingUpdate");
    }

    /**
     * 
     * @param services 
     */
    reload(services: any[]) {
        this.mapping = {};
        this.load(services);
        this.eventChannel.fireEvent("onSchedulePointMappingUpdate");
    }

    /**
     * 
     * @param services 
     */
    load(services: any[]) {
        for (let service of services) {
            if (!service.address) {
                continue;
            }

            const key = service.address.locationId;
            if (!this.mapping.hasOwnProperty(key)) {
                this.mapping[key] = [service];
            }
            else if(!this.mapping[key].find(s => s.id === service.id)) {
                this.mapping[key].push(service);
            }
        }
    }

    /**
     * 
     * @returns 
     */
    getMappingObjRef() {
        return this.mapping;
    }

    /**
     * 
     * @param layerViewId 
     * @param featureId 
     * 
     * @returns 
     */
    get(layerViewId: number, featureId: number): any[] {
        let key = `${layerViewId}_${featureId}`;
        return this.mapping[key] || [];
    }
}
